import { supabaseClient } from "@/supabase/app";
import { enqueueSnackbar } from "notistack";

export async function getSettingsProfileById(id: number) {

  console.log(id+"sure")
  try {

    const { data, error } = await supabaseClient
      .from("settings")
      .select("*")
      .eq("user_id", id)
      .single();

    if (error) {
      console.log("there was a error")
      throw error;
     

    }
    return data;
  } catch (error) {

    console.log("there was a error 2")
    
    return null;
  }
}

export async function updateUserById(id: number, updatedData: Partial<{ 
  email: string; 
  first_name: string; 
  last_name: string; 
  company: string; 
  language: string; 
  phone_number: string; 
  photo_url: string; 
  role: string;
  api_key: string; 
}>) {

  // console.log(last_name)
  try {
    const { data, error } = await supabaseClient
      .from("user")
      .update(updatedData) // Provide the updated fields
      .eq("id", id); // Update the user with the specific id

    if (error) {
      console.log("Error while updating user");
      throw error;
    }

    enqueueSnackbar("Added Successfully", {
      variant: "success",
    });

    return data;
    
  } catch (error) {
    console.log("Error in updating user");
    enqueueSnackbar("An error occurred while updating the user", {
      variant: "error",
    });
    return null;
  }
}


export async function getUserById(id: number) {

  console.log(id)

  console.log("hey hey hey")
  try {

    const { data, error } = await supabaseClient
      .from("user")
      .select("*")
      .eq("id", id)
      .single();

    if (error) {
      console.log("there was a error")
      throw error;
     

    }
    return data;
  } catch (error) {

    console.log("there was a error 2")
    // enqueueSnackbar(`Error fetching profile: ${error.message}`, {
    //   variant: "error",
    // });
    return null;
  }
}

export async function addSettings(formData: any) {
  try {
    let data, error;

    const response = await supabaseClient
      .from("settings")
      .select("*")
      .eq("user_id", formData.user_id)
      .single();

    console.log(response.data);

    if (response.data !== null) {
      const updateResponse = await supabaseClient
        .from("settings")
        .update(formData)
        .eq("user_id", formData.user_id)
        .select()
        .single();

      data = updateResponse.data;
      error = updateResponse.error;
    } else {
      const insertResponse = await supabaseClient
        .from("settings")
        .insert([formData])
        .select()
        .single();

      data = insertResponse.data;
      error = insertResponse.error;
    }

    if (error) {
      throw error;
    }

    console.log(data, "Inserted data");

    enqueueSnackbar("Added Successfully", {
      variant: "success",
    });

    return data; // Return the specific object data after adding
  } catch (error) {
    // enqueueSnackbar(`Error adding profile: ${error.message}`, {
    //   variant: "error",
    // });
    return null; // Optionally return null or undefined to indicate failure
  }
}
